var map = {
	"./en-us/resourcehk": 135,
	"./es-us/resourcehk": 137,
	"./pt-br/resourcehk": 139,
	"./zh-cn/resourcehk": 141
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 355;


//////////////////
// WEBPACK FOOTER
// ./public/hws/i18n ^\.\/.*\/resourcehk$
// module id = 355
// module chunks = 0